import { Trash2 } from "lucide-react";
import { QuantityInput } from "@/components/QuantityInput";

const lineKey = (l) => `${l.item_id}-${l.variant || "base"}`;

export function OrderLinesEditor({ lines, onChange }) {
  const update = (idx, patch) => onChange(lines.map((l, i) => (i === idx ? { ...l, ...patch } : l)));
  const remove = (idx) => onChange(lines.filter((_, i) => i !== idx));
  const total = lines.reduce((s, l) => s + Number(l.price || 0) * l.quantity, 0);

  if (lines.length === 0) {
    return (
      <p className="text-xs text-gray-500 border border-dashed rounded-lg p-4 text-center" data-testid="order-lines-empty">
        No items yet — add dishes from the list below.
      </p>
    );
  }

  return (
    <div className="border rounded-lg overflow-x-auto" data-testid="order-lines">
      <table className="w-full text-xs">
        <thead className="bg-gray-50 text-gray-500 uppercase">
          <tr>
            <th className="text-left p-2">Item</th>
            <th className="text-center p-2">Qty</th>
            <th className="text-right p-2">Unit £</th>
            <th className="text-right p-2">Subtotal</th>
            <th className="p-2" />
          </tr>
        </thead>
        <tbody>
          {lines.map((l, idx) => (
            <tr key={lineKey(l)} className="border-t" data-testid={`order-line-${lineKey(l)}`}>
              <td className="p-2">
                {l.name}
                {l.variant ? <span className="text-[#1aa59a]"> ({l.variant})</span> : null}
              </td>
              <td className="p-2">
                <div className="flex justify-center">
                  <QuantityInput
                    value={l.quantity}
                    onChange={(q) => update(idx, { quantity: q })}
                    testIds={{
                      dec: `line-dec-${lineKey(l)}`,
                      inc: `line-inc-${lineKey(l)}`,
                      input: `line-qty-${lineKey(l)}`,
                    }}
                  />
                </div>
              </td>
              <td className="p-2 text-right">
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={l.price}
                  onChange={(e) => update(idx, { price: e.target.value })}
                  className="w-20 h-7 text-right border rounded px-1 font-mono"
                  data-testid={`line-price-${lineKey(l)}`}
                />
              </td>
              <td className="p-2 text-right font-mono">£{(Number(l.price || 0) * l.quantity).toFixed(2)}</td>
              <td className="p-2 text-right">
                <button
                  type="button"
                  onClick={() => remove(idx)}
                  className="text-gray-400 hover:text-red-500"
                  data-testid={`line-remove-${lineKey(l)}`}
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t bg-gray-50 font-bold">
            <td className="p-2 text-right" colSpan={3}>Total</td>
            <td className="p-2 text-right text-[#1aa59a]" data-testid="order-editor-total">£{total.toFixed(2)}</td>
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
